import axios from 'axios'
import md5 from 'js-md5'
import { Message, MessageBox, Notification } from 'element-ui'
import { getToken } from '@/utils/token.js'
import { store } from '@/store/store'
import utils from '@/utils'
import router from '@/router'
import customMessageBox from '@/components/base/messageBox'
let BASE_URL = window.BASE_URL
if (process.env.NODE_ENV === 'development') {
  BASE_URL = BASE_URL.dev
} else if (process.env.NODE_ENV === 'production') {
  BASE_URL = BASE_URL.proc
} else if (process.env.NODE_ENV === 'test') {
  BASE_URL = BASE_URL.test
} else if (process.env.NODE_ENV === 'test-pro') {
  BASE_URL = BASE_URL.testPro
} else if (process.env.NODE_ENV === 'prd') {
  BASE_URL = BASE_URL.prd
}
// 不用提示的code
const noTipsArr = [20011, 20017, 20019, 20016, 400, 20025]

// create axios

const CancelToken = axios.CancelToken
let source = CancelToken.source()

const service = axios.create({
  baseURL: BASE_URL,
  timeout: 300000
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (getToken()) {
      // 如果存在token
      config.headers['login_code'] = getToken()
    }
    // 添加cancelToken
    config.cancelToken = source.token
    const lang = localStorage.lang
    if (lang) {
      // config.headers['language_id'] = lang === 'cn' ? 30 : 29
      const languageMap = {
        'en': 29,
        'cn': 30,
        'jp': 687
      }
      config.headers['language_id'] = languageMap[lang] || 29
    }
    // 参数带入 requestName 防止多次请求
    const requestName = config.data ? config.data.requestName : false
    if (requestName) {
      if (axios[requestName] && axios[requestName].cancel) {
        axios[requestName].cancel()
      }
      config.cancelToken = new CancelToken(c => {
        axios[requestName] = {}
        axios[requestName].cancel = c
      })
    } else {
      config.cancelToken = source.token
    }
    const uri = config.url
    if (uri !== '/auth/public/uploadFile/water' && uri !== '/auth/public/upload_file' && uri !== '/auth/public/download_file' && uri !== '/manage/inci/basfMark/upload' && uri !== '/manage/inci/upload' & uri !== '/manage/filterKeyword/upload' & uri !== '/manage/userCompany/upload' && uri !== '/auth/public/upload/aliFile') {
      const currDate = (new Date()).getTime()
      const webIdentification = 'b3cf629e-d1e8-46ad-822a-e2a2eb56b243'
      const str = utils.randomString(16)
      const params = { ...config.data, currDate, str, uri, webIdentification }
      const signParams = {
        ...config,
        data: {
          ...config.data,
          currDate,
          str,
          sign: md5(JSON.stringify(params))
        }
      }
      return signParams
    } else {
      return config
    }
  },
  error => {
    return Promise.reject(error)
  }
)

const loginOutToHomeoutside = async () => {
  await store.dispatch('login/logoutApi')
  const isHomeoutside = window.location.href.includes('/homeoutside')
  if (isHomeoutside) {
    window.location.reload()
  }
  const fullPathArr = window.location.href.split('#/')
  if (fullPathArr && fullPathArr[1]) {
    let fullPath = fullPathArr[1]
    router.push(`/homeoutside?redirect=true`)
    localStorage.setItem('Admin-Redirect', fullPath)
    window.location.reload()
  } else {
    window.location.href = '/'
  }
}

// response interceptor
service.interceptors.response.use(
  async response => {
    if (response.status === 200) {
      const res = response.data
      if (res.errorCode) {
        // 处理错误信息
        // 和开发约定，600开头的错误码不走公共错误提示
        if (res.errorCode !== 200 && !/^600/.test(res.errorCode)) {
          // session过期
          if (res.errorCode === 20008) {
            source.cancel()
            source = CancelToken.source()
            MessageBox.alert(window.$lang('message.reLoginTips'), window.$lang('message.loginTimeout'), {
              confirmButtonText: 'O K',
              showClose: false,
              center: true,
              callback: async action => {
                loginOutToHomeoutside()
              }
            })
          } else if (res.errorCode === 20012 || res.errorCode === 20006) {
            // 用户权限变更
            source.cancel()
            source = CancelToken.source()
            if (document.getElementsByClassName('permission-changed').length === 0) {
              MessageBox.alert(window.$lang('message.permissionChanged'), window.$lang('message.tips'), {
                confirmButtonText: window.$lang('btn.ok'),
                showClose: false,
                center: false,
                customClass: 'permission-changed',
                callback: async action => {
                  if (res.errorCode === 20012) {
                    await store.dispatch('login/updateSessionApi')
                  }
                  store.commit('login/SET_AUTH', {menu: [], button: [], page: []})
                  sessionStorage.removeItem('authList')
                  store.commit('login/SET_MENU', [])
                  sessionStorage.removeItem('menuList')
                  window.location.reload()
                }
              })
            }
          } else if (res.errorCode === 20013) {
            // 账号被停用
            source.cancel()
            source = CancelToken.source()
            Message.error(res.errorMsg)
            loginOutToHomeoutside()
            // await store.dispatch('login/logoutApi')
            // window.location.href = '/'
          } else if (res.errorCode === 20022) {
            // 单点登录
            source.cancel()
            source = CancelToken.source()
            const message = window.$lang('message.loginDenied.content', { current: '<span style="font-weight: bold">CS.DlitE3-X@basf.com.</span>' })
            customMessageBox({
              title: window.$lang('message.loginDenied.title'),
              message,
              dangerouslyUseHTMLString: true,
              callback: async action => {
                // window.location.href = '/'
                const isHomeoutside = window.location.href.includes('/homeoutside')
                if (isHomeoutside) {
                  window.location.reload()
                }
                // await store.dispatch('login/logoutApi')
                const fullPathArr = window.location.href.split('#/')
                if (fullPathArr && fullPathArr[1]) {
                  let fullPath = fullPathArr[1]
                  localStorage.setItem('Admin-Redirect', fullPath)
                  router.push(`/homeoutside?redirect=true`)
                  window.location.reload()
                } else {
                  window.location.href = '/'
                }
              },
              beforeClose: async (action, instance, done) => {
                await store.dispatch('login/logoutApi')
                done()
              }
            })
          } else if (res.errorCode === 20026) {
            // reset pwd
            source.cancel()
            source = CancelToken.source()
            const message = window.$lang('message.resetPwd.content')
            MessageBox.alert(message, {
              confirmButtonText: 'O K',
              showClose: false,
              center: true,
              callback: async action => {
                // await store.dispatch('login/logoutApi')
                // window.location.href = '/'
                loginOutToHomeoutside()
              }
            })
          } else if (res.errorCode === 20030) {
            // 用户权限变更后没有任何页面权限
            source.cancel()
            source = CancelToken.source()
            MessageBox.alert(window.$lang('message.changedNoPermission'), 'Tips', {
              confirmButtonText: 'O K',
              showClose: false,
              center: false,
              callback: async action => {
                // await store.dispatch('login/logoutApi')
                // window.location.href = '/'
                loginOutToHomeoutside()
              }
            })
          } else if (res.errorCode === 30021) {
            // 当前commentApprove状态为不显示，新增评论返回30021
            Message.success(res.errorMsg)
            return Promise.resolve(res)
          } else if (res.errorCode === 50036) {
            // 防爬拦截
            source.cancel()
            source = CancelToken.source()
            store.commit('login/UPDATE_IS_SHOW_CHECK_CODE', true)
          } else if (res.errorCode === 30022 || res.errorCode === 50001) {
            // disable data
            source.cancel()
            source = CancelToken.source()
            router.push({ name: 'notFound' })
          } else if (res.errorCode === 30023) {
            // 不可见
            source.cancel()
            source = CancelToken.source()
            router.push({ name: 'noAccess' })
          } else if (res.errorCode === 20027) {
            const lastPasswordTime = res.errorMsg
            // 账号快到期提示修改密码
            Notification({
              title: window.$lang('message.updatePasswordTip.title'),
              dangerouslyUseHTMLString: true,
              duration: 0,
              message: window.$lang('message.updatePasswordTip.content', { current: lastPasswordTime || window.$lang('message.updatePasswordTip.noPassRecord') })
            })
            return res
          } else if (res.errorCode === 20028) {
            // 账号到期强制修改密码
            source.cancel()
            MessageBox.confirm(window.$lang('message.accountLockTip.content'), window.$lang('message.accountLockTip.title'), {
              distinguishCancelAndClose: true,
              dangerouslyUseHTMLString: true,
              confirmButtonText: window.$lang('txt.changePassword'),
              cancelButtonText: window.$lang('btn.cancel')
            }).then(() => {
              source = CancelToken.source()
              store.commit('login/UPDATE_CHANGE_SHOW', true)
            }).catch(async action => {
              source = CancelToken.source()
              // await store.dispatch('login/logoutApi')
              // window.location.href = '/'
              loginOutToHomeoutside()
            })
          } else if (res.errorCode === 50050) {
            // 6个月未登录申请邮件 重复发送提示
            return res
          } else {
            if (res.errorMsg && !noTipsArr.includes(res.errorCode)) {
              Message.error(res.errorMsg || 'Error')
            }
            // return Promise.reject(new Error(res.errorMsg || 'Error'))
            return Promise.reject(res)
          }
        } else {
          return res
        }
      } else {
        // 下载跳过拦截
        return response
      }
    } else {
      Message.error(response.statusText || 'Error')
      return Promise.reject(new Error(response.statusText || 'Error'))
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/axios/config.js